import { TeaserSlider } from './teaserSlider';
import { SessionStorage } from './sessionStorage';
import { Sites } from '../sites/Sites';

/**
 *
 *
 * @export
 * @class TeaserSliderManager
 */
export class TeaserSliderManager {
  private _slideShow: FrameRequestCallback = null;
  private _teaserSlider: TeaserSlider;
  private _timer;
  private static _instance: TeaserSliderManager;
  private _rootElement: HTMLElement = document.querySelector('.ow-teaser');
  private _sliderElement: HTMLElement = this._rootElement.querySelector('.ow-teaser__slider');
  private _openTeaserSliderButton: HTMLElement = this._rootElement.querySelector(
    '.ow-teaser__open-button-circle'
  );
  private _closeTeaserSliderButton: HTMLElement = this._rootElement.querySelector(
    '.ow-teaser__close-button'
  );
  private _openButtonText: HTMLElement = this._rootElement.querySelector(
    '.ow-teaser__open-button-text'
  );
  private _sites: Sites;
  private _sliderHideText: HTMLElement;
  private _requestAnimationFrameId;

  /**
   *Creates an instance of TeaserSliderManager.
   * @memberof TeaserSliderManager
   */
  constructor() {
    this._teaserSlider = new TeaserSlider();
    this._sites = new Sites();
    //Singleton
    if (TeaserSliderManager._instance) {
      return this;
    } else {
      TeaserSliderManager._instance = this;
    }
    this.events();
    this._teaserSlider.animate();
    this._openTeaserSliderButton.addEventListener('click', () => this.bootstrap());
  }

  /**
   *
   *
   * @memberof TeaserSliderManager
   */
  public bootstrap(): void {
    this.startAnimation();
    // *Anzeige von Close Button
    this._openButtonText.style.visibility = 'hidden';
    this._teaserSlider.show();
    setTimeout(
      () => this._closeTeaserSliderButton.classList.add('ow-teaser__close-button--show'),
      1500
    );
    this._openTeaserSliderButton.classList.remove('ow-teaser__open-button-circle--show');
  }

  /**
   * * Platzhalter wird angezeigt anstatt Slider
   * * Event falls Benutzer Slider sehen will
   *
   * @memberof TeaserSliderManager
   */
  public onCall(): void {
    this._openTeaserSliderButton.classList.add('ow-teaser__open-button-circle--show');
  }

  /**
   * * Schließt den Slider und öffnet den Platzhalter
   *
   * @private
   * @memberof TeaserSliderManager
   */
  private closeSlider(): void {
    this.fadeOut(false);
    this._closeTeaserSliderButton.classList.remove('ow-teaser__close-button--show');
    this._sliderElement.classList.remove('ow-teaser__slider--show');
    SessionStorage.setStorage(true);
    this._openTeaserSliderButton.classList.add('ow-teaser__open-button-circle--show');
    this._teaserSlider.hide();
    this.stopAnimation();
  }

  /**
   *
   *
   * @private
   * @memberof TeaserSliderManager
   */
  private events(): void {
    this._sliderElement.addEventListener('mouseenter', () => this.stopAnimation());
    this._sliderElement.addEventListener('mouseleave', () => this.startAnimation());
    this._sliderElement.addEventListener('click', () => this._sites.open());

    this._closeTeaserSliderButton.addEventListener('mouseenter', () => this.fadeOut(true));
    this._closeTeaserSliderButton.addEventListener('mouseleave', () => this.fadeOut(false));
    this._closeTeaserSliderButton.addEventListener('click', () => this.closeSlider());

    this._openTeaserSliderButton.addEventListener(
      'mouseenter',
      () => (this._openButtonText.style.visibility = 'visible')
    );
    this._openTeaserSliderButton.addEventListener('click', () => SessionStorage.setStorage(false));
  }

  /**
   * *Bei Hover über den Schließen Button wird der Slider leicht verschoben und durchsichtig
   *
   *
   * @private
   * @param {boolean} fadeOut
   * @memberof TeaserSliderManager
   */
  private fadeOut(fadeOut: boolean): void {
    if (fadeOut) {
      this._sliderHideText = document.createElement('span');
      this._sliderHideText.classList.add('ow-teaser__slider-explanation');
      this._sliderHideText.innerText = 'Online-Welt ausblenden';
      this._sliderElement
        .querySelector('.active')
        .insertAdjacentElement('afterbegin', this._sliderHideText);
      this._sliderElement.style.transform = 'translate(10%)';
      this._sliderElement.style.opacity = '.9';
    } else {
      this._sliderElement.style.transform = '';
      this._sliderElement.style.opacity = '';
      this._sliderHideText != null ? this._sliderHideText.remove() : null;
    }
  }

  /**
   *
   *
   * @private
   * @memberof TeaserSliderManager
   */
  private startAnimation(): void {
    this._slideShow = (): void => {
      this._timer = setTimeout(() => {
        this._teaserSlider.animate();
        requestAnimationFrame(this._slideShow);
      }, 5000);
    };
    this._requestAnimationFrameId = requestAnimationFrame(this._slideShow);
  }

  /**
   *
   *
   * @private
   * @memberof TeaserSliderManager
   */
  private stopAnimation(): void {
    clearTimeout(this._timer);
  }
}
